// Revisado: 2025-12-18 [I18n Scan]
/**
 * Calculates the adjusted skill score based on character aptitudes.
 * Based on LogicToCalculate.js reference.
 * 
 * Formula: AdjustedScore = Score * Multiplier / 100
 * 
 * Multipliers based on Aptitude Rank:
 * S, A -> 110
/**
 * Calculates the adjusted skill score based on character aptitudes.
 * Based on LogicToCalculate.js reference.
 * 
 * Formula: AdjustedScore = Score * Multiplier / 100
 * 
 * Multipliers based on Aptitude Rank:
 * S, A -> 110
 * B, C -> 90
 * D, E, F -> 80
 * G -> 70
 * 
 * @param {Object} skill - The skill object containing Score_Value, Surface_Distance, Dependence
 * @param {Object} aptitudes - The character's aptitudes object (e.g. { turf: 'A', short_distance: 'S', ... })
 * @returns {Object} Result object containing:
 *  - adjustedScore: number
 *  - originalScore: number
 *  - multiplier: number (percentage, e.g. 110)
 *  - aptitude: string (e.g. 'Mile' or 'Runner')
 *  - rank: string (e.g. 'S')
 *  - isCalculated: boolean
 */
export const calculateAdjustedScore = (skill, aptitudes) => {
    const defaultResult = {
        adjustedScore: 0,
        originalScore: 0,
        multiplier: 100,
        aptitude: null,
        rank: null,
        isCalculated: false
    };

    if (!skill || !skill.Score_Value) return defaultResult;

    const baseScore = parseFloat(skill.Score_Value);
    if (isNaN(baseScore)) return defaultResult;

    defaultResult.originalScore = baseScore;
    defaultResult.adjustedScore = baseScore;

    if (!aptitudes) return defaultResult;

    // Map Skill Properties to Aptitude Keys
    // We map the values found in 'Surface_Distance' and 'Dependence' to our internal aptitude keys.

    const distanceMap = {
        'Short': 'short_distance',
        'Sprint': 'short_distance',
        'Mile': 'mile',
        'Medium': 'medium_distance',
        'Long': 'long_distance'
    };

    const strategyMap = {
        'Front': 'runner',
        'Runner': 'runner',
        'Escape': 'runner',
        'Pace': 'leader',
        'Leader': 'leader',
        'Late': 'betweener',
        'Betweener': 'betweener',
        'End': 'chaser',
        'Chaser': 'chaser'
    };

    // Determine which aptitude applies
    let aptitudeKey = null;
    let aptitudeLabel = null;

    // Check Distance first (Surface_Distance)
    if (skill.Surface_Distance) {
        const distVal = skill.Surface_Distance.trim();
        if (distanceMap[distVal]) {
            aptitudeKey = distanceMap[distVal];
            aptitudeLabel = distVal;
        }
    }

    // If no distance match, check Strategy (Dependence)
    if (!aptitudeKey && skill.Dependence) {
        const depVal = skill.Dependence.trim();
        if (strategyMap[depVal]) {
            aptitudeKey = strategyMap[depVal];
            aptitudeLabel = depVal;
        }
    }

    // If no relevant aptitude found, return base result
    if (!aptitudeKey) return defaultResult;

    // Get the character's rank for this aptitude
    const rank = aptitudes[aptitudeKey];
    if (!rank) return defaultResult; // If aptitude not defined, return base

    // Multiplier Map (from LogicToCalculate.js)
    const scoreMap = {
        'S': 110, 'A': 110,
        'B': 90, 'C': 90,
        'D': 80, 'E': 80, 'F': 80,
        'G': 70
    };

    const multiplier = scoreMap[rank] || 100;

    // Calculate Adjusted Score
    // Formula: Score * Multiplier / 100
    const adjustedScore = (baseScore * multiplier) / 100;

    return {
        adjustedScore: Math.round(adjustedScore),
        originalScore: baseScore,
        multiplier: multiplier,
        aptitude: aptitudeLabel,
        rank: rank,
        isCalculated: multiplier !== 100 // Only consider it "calculated" if it changes (or if we want to show it even if 100%?) User said "solo en los casos que se tuvo que realizar un calculo". Usually 100% means no change, but technically it IS calculated. But S/A is 110. B/C is 90. So almost always calculated unless it's 100 which is not in the map (default).
    };
};
